// src/features/TeamChat/components/TeamChatBoundary.tsx
import * as Sentry from '@sentry/react'
import { Component } from 'react'
import type { ReactNode } from 'react'

type Props = { children: ReactNode }
type State = { failed: boolean }

// A crash in the widget hides the widget instead of sending the whole app to /error/500.
export class TeamChatBoundary extends Component<Props, State> {
  state: State = { failed: false }

  static getDerivedStateFromError(): State {
    return { failed: true }
  }

  componentDidCatch(error: Error) {
    Sentry.captureException(error, { tags: { feature: 'team-chat' } })
  }

  render() {
    return this.state.failed ? null : this.props.children
  }
}
